// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__U4rpQ","social":"footer_social__fl_KD","build":"footer_build__cEdAY"};